import { useQuery } from 'react-query';
import { api } from '../../../../static/api';
import { ApiMonthlyStatsResponse, GamesMonthlyStatsParams, IMonthlyStats } from '../../../../types/GameTypes';
import { QueryAliases } from '../../../../types/QueryAliases';
import useAxiosInstance from '../../../axios/useAxiosInstance';

interface useCreatedGamesStatisticsProps {
  params: GamesMonthlyStatsParams;
}

const useCreatedGamesStatistics = ({ params }: useCreatedGamesStatisticsProps) => {
  const axiosInstance = useAxiosInstance();

  const { email, gameType, year } = params;

  const getQueryParams = () => ({
    ...(!!email && { email }),
    ...(!!gameType && { gameType }),
    ...(!!year && { year }),
  });

  const { data, refetch, isSuccess, isLoading, isError } = useQuery(
    [QueryAliases.ALL_GAME_STATISTICS.CREATED_GAMES, email, gameType, year],
    () =>
      axiosInstance.get(api.endpoints.ALL_GAME_STATISTICS.CREATED_GAMES(), {
        params: getQueryParams(),
      }),
  );

  const apiStatistics: ApiMonthlyStatsResponse | undefined = data?.data;

  const iStatistics: IMonthlyStats | undefined = !!apiStatistics
    ? {
        totalCount: apiStatistics.totalCount,
        countByMonth: (apiStatistics.countByMonth ?? []).map(monthItem => ({
          month: monthItem.month,
          count: monthItem.count,
        })),
      }
    : undefined;

  return {
    createdGamesStatistics: iStatistics,
    refetch,
    isSuccess,
    isLoading,
    isError,
  };
};

export default useCreatedGamesStatistics;
